<div class="container px-8">
    <!-- <h2 class="text-primary poppins-medium px-8">Add User</h2> -->
    <app-title title="Add User"></app-title>
    <div class="border-solid border-gray-200 border rounded-lg px-16 py-8 ">
        <form [formGroup]="addUserForm">
            <section class="grid grid-cols-2 gap-8">
                <section class="flex flex-col gap-2">
                    <label for="firstName">First Name
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="firstName" [required]="true" />
                    <small class="text-red-500"
                    *ngIf="checkErrorMessage(addUserForm, 'firstName', isSubmitted())" >
                        First Name is required.
                    </small>
                </section>
                <section class="flex flex-col gap-2">
                    <label for="lastName">Last Name
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="lastName" [required]="true" />
                    <small class="text-red-500"
                    *ngIf="checkErrorMessage(addUserForm, 'lastName', isSubmitted())">
                        Last Name is required.
                    </small>
                </section>


                <section class="flex flex-col gap-2">
                    <label for="email">Email
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="email" [required]="true" />
                    <small class="text-red-500"
                    *ngIf="checkErrorMessage(addUserForm, 'email', isSubmitted())">
                        Please enter a valid email.
                    </small>
                </section>


                <section class="flex flex-col gap-2">
                    <label for="mobileNumber">Mobile Number
                    </label>
                    <p-inputGroup>
                        <p-inputGroupAddon>+91</p-inputGroupAddon>
                        <input type="tel" pInputText placeholder="" formControlName="mobile" maxlength="10" [required]="true"/>
                    </p-inputGroup>

                </section>


                <section class="flex flex-col gap-2">
                    <label for="gender">Gender
                        <span style="color: red;">*</span>
                    </label>
                    <p-dropdown styleClass="!w-full" formControlName="gender" [options]="genderOptions" />
                    <small class="text-red-500" *ngIf="checkErrorMessage(addUserForm, 'gender', isSubmitted())">Gender is required.</small>
                </section>

                <section class="flex flex-col gap-2">
                    <label for="dob">Date Of Birth
                    </label>
                    <p-calendar formControlName="dob" styleClass="!w-full" [(ngModel)]="date" [iconDisplay]="'input'"
                        [showIcon]="true" inputId="icondisplay" />
                </section>


                <section class="flex flex-col gap-2">
                    <label for="userRole">User Role
                        <span style="color: red;">*</span>

                    </label>
                    <p-multiSelect  styleClass="!w-full" formControlName="roles" optionValue="id" optionLabel="name"
                    [options]="roleOptions" />

                    <small class="text-red-500" *ngIf="checkErrorMessage(addUserForm, 'roles', isSubmitted())">Role is required.</small>


                </section>
                <section class="flex flex-col gap-2">
                    <label for="gender">Organization
                        <span style="color: red;">*</span>
                    </label>
                    <p-dropdown styleClass="!w-full" formControlName="organization"  optionValue="id"  optionLabel="name"  [options]="organizationOptions" />
                    <small class="text-red-500" *ngIf="checkErrorMessage(addUserForm, 'organization', isSubmitted())">Organization is required.</small>
                </section>
                <section class="flex flex-col gap-2">
                    <label for="gender">GSTIN Number
                        <span style="color: red;">*</span>
                    </label>
                    <input pInputText formControlName="gstInNumber" [maxlength]="15" [required]="true" />
                    <small *ngIf="checkErrorMessage(addUserForm, 'gstInNumber', isSubmitted())" class="text-red-500 text-sm mt-1">
                        GST Number is required</small>
                </section>
                <div class="flex flex-col gap-2">
                    <label>Organization Name</label>
                    <input pInputText formControlName="orgName" [autocomplete]="true" [required]="true" />
                  </div>
                  <div *ngIf="checkErrorMessage(addUserForm, 'orgName', isSubmitted())" class="text-red-500 text-sm mt-1">
                    Organization Name is required</div>
            </section>
            <div class="card flex justify-end mt-6">
                <p-button label="Submit" (onClick)="addUser()" />
            </div>
        </form>
    </div>
</div>
